import BackgroundImage from "@components/BackgroundImageCst";
import { Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import AssociationTableCst from "@components/AssociationTableCst";
import { useEffect, useState } from "react";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { usePostDetail } from "@hooks/useFetchDetail";
import { useNavigate } from "react-router-dom";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { useAuth } from "@context/auth";
import { RolesDigitedEnum } from "@context/auth/types";

const DashboardEnablement: React.FC = () => {
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    key?: string | number;
  }>();
  const { t } = useTranslation(["dashboard-enablement-page", "common"]);
  const [dashboarAssociation, setDashboardAssociation] = useState<any>([]);
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const { trigger } = usePostDetail(ServicesURL.enableDisableDashboard);
  const isPO = user?.roles.includes(RolesDigitedEnum.PRODUCT_OWNER);

  const { dataTable } = useFetchTable(
    `${ServicesURL.getDashboard}?getUsersAndRoles=true&getCorporates=true${isPO ? "" : `&userId=${user?.id_user}`}`,
    PagesID["dashboard.corporate-association"],
  );

  const onDashboardAssociation = async (selected: any) => {
    setOpenToast({ s: StatusEnum.LOADING, message: "loading" });
    const objToDashboardAssociation: any = Object.keys(selected).map(
      (key: string) => {
        if (key.includes("||")) {
          return {
            id: key.split("||")[0],
            label: key.split("||")[1],
          };
        }
      },
    );

    const initialSelectionFormatted = objToDashboardAssociation.map(
      (item: any) => {
        return item;
      },
    );

    const listToSend = objToDashboardAssociation.filter(
      (obj1: any) => !dataTable.output.some((obj2: any) => obj1.id === obj2.id),
    );

    const modifiedList = listToSend.map((item: any) => {
      return item;
    });

    const idsExist = dataTable.output.map((item: any) => {
      return {
        id: item.id,
        label: item.originalName,
      };
    });

    const idsToAdd = modifiedList.filter(
      (item: any) => !idsExist.includes(Number(item)),
    );

    const idsToDelete = idsExist.filter(
      (itemToSend: any) =>
        !initialSelectionFormatted.some(
          (detail: any) => detail.id === itemToSend.id,
        ),
    );

    const toSend: any = [...idsToAdd, ...idsToDelete];

    const arrayFinal = toSend.map((item: any) => {
      return {
        id: item.id,
        associatedCorporates: null,
        associatedRoles: null,
        associatedUsersNumber: null,
        openLearningPlatformName: null,
        originalName: item.label,
        quicksightUrl: null,
      };
    });

    try {
      await trigger(arrayFinal);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      console.error(error);
      setOpenToast(undefined);
    }
  };

  useEffect(() => {
    if (!dataTable) return;
    const association = dataTable?.output.map((item: any) => {
      const isDisabled =
        !!item.associatedCorporates.length ||
        item.associatedRoles.length ||
        item.associatedUsersNumber > 0;
      return {
        id: item.id,
        label: item.originalName,
        disabled: isDisabled,
      };
    });
    setDashboardAssociation(association);
    setTimeout(() => {
      setIsReady(true);
    }, 500);
  }, [dataTable]);

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-dashboard.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("hero-title")} description={t("hero-description")} />
        {!!isReady && (
          <AssociationTableCst
            association={dashboarAssociation}
            setAssociation={null}
            callBackAssociation={onDashboardAssociation}
            setCloseAssociation={null}
            service={`${ServicesURL.getQuicksightDashboard}`}
            pageID={PagesID["dashboard.enablement"]}
            title={""}
            enableMultiRowSelection={true}
            customBackAction={() => navigate(-1)}
            hiddenFilters={true}
          />
        )}

        <ModalConfirmsCst
          open={!!openToast}
          title={t("hero-title-add")}
          description={""}
          onCallBackClosed={() => {
            setOpenToast(undefined);
          }}
          status={openToast}
        />
      </Container>
    </AnimationFadeIn>
  );
};

export default DashboardEnablement;
